import React, { useMemo } from 'react';
import type { Dispatch } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import { SelectFilter } from './SelectFilter';
import { CompletionOptions, FilterKeys } from './filtersDefinitions';
import type { FiltersState } from './useFiltersReducer';

const i18n = defineMessages({
	completionLabel: {
		id: 'home.views.tasks.filters.label.completion',
		defaultMessage: 'Status',
		description:
			'The label text for a selector to filter tasks by their status of either done or ongoing.',
	},
	optionDone: {
		id: 'home.views.tasks.filters.options.completion.done',
		defaultMessage: 'Done',
		description: 'An option for the task completion selector to select done tasks.',
	},
	optionOngoing: {
		id: 'home.views.tasks.filters.options.completion.ongoing',
		defaultMessage: 'Ongoing',
		description: 'An option for the task completion selector to select ongoing tasks.',
	},
});

interface SelectCompletionProps {
	filterDispatch: Dispatch<any>;
	filterState: FiltersState;
}

export const SelectCompletion = ({ filterDispatch, filterState }: SelectCompletionProps) => {
	const { formatMessage } = useIntl();

	const options = useMemo(
		() => [
			{
				label: formatMessage(i18n.optionDone),
				value: CompletionOptions.DONE,
			},
			{
				label: formatMessage(i18n.optionOngoing),
				value: CompletionOptions.ONGOING,
			},
		],
		[formatMessage],
	);

	const value = options.find(({ value }) => value === filterState.filters[FilterKeys.COMPLETED]);

	return (
		<SelectFilter<CompletionOptions>
			options={options}
			filterKey={FilterKeys.COMPLETED}
			label={formatMessage(i18n.completionLabel)}
			inputId="completion-filter"
			filterDispatch={filterDispatch}
			value={value}
		/>
	);
};
